<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <h5 class="d-inline">
          {{ $t('lang.bookings.store_details') }}
        </h5>
        <section
          id="description"
          class="booking-section"
        >
          <div class="detail_title_1">
            <h2 class="color_text mt-2 mb-0">
              {{ booking.store.name }}
            </h2>
            <h6 class="small_h6">
              {{ $t('lang.categories.' + booking.store.category_id).toUpperCase() }}
            </h6>
          </div>

          <div class="col-lg-12 add_bottom_30">
            <StoreImages
              :store="booking.store"
              :booking-confirm="bookingConfirm"
              :img-class="'details-img booking-img'"
            />
          </div>

          <StoreServices
            v-if="booking.booking_status != 'closed'"
            :store="booking.store"
          />

          <div
            v-if="booking.booking_status != 'closed'"
            class="add_bottom_30"
          >
            <StoreSchedule
              id="schedule"
              :store="booking.store"
              :from-booking="true"
            />
          </div>

          <div
            id="location"
            class="add_bottom_30"
          >
            <h5 class="booking-subtitle">
              {{ $t('lang.stores.location') }}
            </h5>

            <h4>
              <small v-if="booking.booking_status === 'pending' || booking.booking_status === 'cancelled'">
                {{ $t('lang.bookings.exact_location') }}
              </small>
              <small v-else>
                {{ booking.store.full_address }}
              </small>
            </h4>

            <div
              id="map"
              class="map booking-img col-lg-12 "
              style="border-radius: 3px;"
            >
              <BookingMapComponent
                :place="[booking.store.latitude_coordinate, booking.store.longitude_coordinate]"
                :booking-status="booking.booking_status"
              />
            </div>
          </div>

          <div
            id="chat"
            class="add_bottom_30"
          >
            <h5 class="booking-subtitle">
              Chat
            </h5>
            <BookingChat
              v-if="showChat"
              :booking="booking"
            />
          </div>

          <!-- End Map -->
        </section>
        <!-- /section -->

        <hr>

        <section
          v-if="booking.store.last_reviews.length && showReviews"
          id="reviews"
          style="scroll-margin-top: 110px;"
        >
          <div>
            <h5 class="booking-subtitle">
              {{ $t('lang.stores.reviews') }}
            </h5>
            <StoreReview
              v-for="review in booking.store.last_reviews"
              :key="review.id"
              :review="review"
            />
          </div>
        </section>
      </div>
    </div>
    <!-- /row -->
  </div>
</template>

<script>

import StoreImages from '@/components/Store/StoreImages';
import StoreServices from '@/components/Store/StoreServices';
import StoreSchedule from '@/components/Store/StoreSchedule';
import BookingChat from '@/components/Booking/BookingChat';
import LeaveReview from '@/components/Booking/LeaveReview';
import StoreReview from '@/components/Store/StoreReview';
import BookingMapComponent from '@/components/Booking/BookingMapComponent';

export default {
  name: 'StoreInfo',
  components: {
    StoreSchedule,
    BookingMapComponent,
    BookingChat,
    LeaveReview,
    StoreReview,
    StoreImages,
    StoreServices,
  },

  props: {
    booking: {
      type: Object,
      required: true,
    },
    showChat: {
      type: Boolean,
      default: false,
    },
    showReviews: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    bookingConfirm() {
      if (this.booking.booking_status === 'pending' || this.booking.booking_status === 'cancelled') {
        return false;
      }
      return true;
    },
  },
};
</script>

<style scoped>

</style>
